<!--
 * @Author: Junjie
 * @Date: 2022-09-14 17:04:37
 * @LastEditTime: 2023-01-16 21:49:53
 * @email: 781433561@qq.com
 * @Description: 
 * @FilePath: /iplus-iwt-fe/src/views/tech/read/modules/IotSensorReadAddForm.vue
-->
<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container>
      <!-- 主表单区域 -->
      <a-form-model :model="model" :rules="validatorRules" @keyup.enter.native="submitForm" ref="form" slot="detail">
        <a-row>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="抄表时间" prop="dataTime">
              <j-date
                :show-time="true"
                date-format="YYYY-MM-DD HH:mm:ss"
                placeholder="请选择抄表时间"
                style="width: 100%"
                v-model="model.dataTime"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="负责人" prop="responsibleId">
              <j-dict-select-tag
                :dictCode="`sys_user,realname,id,del_flag='0' and executor_duty = 1 and rel_tenant_ids='${this.$ls.get('TENANT_ID')}' order by realname`"
                pageSize="100"
                placeholder="请选择负责人"
                type="list"
                v-model="model.responsibleId"
              />
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </j-form-container>
    <!-- 子表单区域 -->
    <a-tabs>
      <a-tab-pane :forceRender="true" key="sensorReadRecord" tab="抄表记录">
        <j-vxe-table
          :columns="columns"
          :dataSource="dataSource"
          :loading="loading"
          :maxHeight="500"
          :rowNumber="false"
          :rowSelection="false"
          :toolbar="false"
          @valueChange="valueChange"
          keep-source
          ref="table"
          size="small"
        />
      </a-tab-pane>
    </a-tabs>
  </a-spin>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import { httpAction, getAction } from '@/api/manage'
  import { JVXETypes } from '@/components/jeecg/JVxeTable'
  import { filterMultiDictText } from '@/components/dict/JDictSelectUtil'

  import { execMathExpress } from '@/utils/execMathExpress.js'

  import moment from "dayjs";

  export default {
    name: 'IotSensorReadIAddForm',
    mixins: [JeecgListMixin, mixinDevice],
    components: {
    },
    data () {
      return {
        confirmLoading: false,
        description: '抄表项登记',
        ipagination: {
          pageSize: 9999,
        },
        // 表头
        columns: [
          {
            title: '抄表项名称',
            align: "center",
            key: 'itemName',
            width: 320,
          },
          {
            title: '简称',
            align: "center",
            key: 'itemShortName'
          },
          {
            title: '值',
            key: 'value',
            type: JVXETypes.inputNumber,
            placeholder: '请输入${title}',
            defaultValue: '',
            disabled: (row) => { return !!row && row.sensorReadSource === 'calc' },
          },
          {
            title: '单位',
            align: "center",
            key: 'dataUnit',
            width: 60,
          },
          {
            title: '照片',
            align: "center",
            type: JVXETypes.image,
            key: 'picture',
            token: true,

          },
          {
            title: '数据来源',
            align: "center",
            width: 80,
            key: 'sensorReadSource_dictText'
          },
        ],
        labelCol: {
          xs: { span: 24 },
          sm: { span: 6 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        model: {
          dataTime: moment().format('YYYY-MM-DD HH:mm:ss'),
          responsibleId: '',
        },
        validatorRules: {
          dataTime: [
            { required: true, message: '请输入抄表时间!' },
          ],
        },
        url: {
          list: "/read/item/list",
          add: "/read/records/addBatch",
        },
        dictOptions: {},
        superFieldList: [],
      }
    },
    created () {
      this.getSuperFieldList();

      this.model.responsibleId = this.$ls.get('Login_UserId')
    },
    computed: {
      importExcelUrl: function () {
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
    },
    methods: {
      initDictConfig () {
      },
      getSuperFieldList () {
        let fieldList = [];
        fieldList.push({ type: 'string', value: 'itemName', text: '抄表项名称', dictCode: '' })
        fieldList.push({ type: 'string', value: 'itemShortName', text: '简称', dictCode: '' })
        fieldList.push({ type: 'string', value: 'itemDesc', text: '详情', dictCode: '' })
        fieldList.push({ type: 'string', value: 'pointCode', text: '点号', dictCode: '' })
        fieldList.push({ type: 'string', value: 'devProcessId', text: '工艺', dictCode: '`iwt-wf`.dev_process,process_name,id' })
        fieldList.push({ type: 'string', value: 'devId', text: '设备', dictCode: '' })
        fieldList.push({ type: 'string', value: 'expression', text: '计算公式', dictCode: '' })
        fieldList.push({ type: 'string', value: 'dataUnit', text: '单位', dictCode: '' })
        fieldList.push({ type: 'int', value: 'sort', text: '排序', dictCode: '' })
        this.superFieldList = fieldList
      },
      valueChange (data) {
        const row = data.row;
        let records = this.dataSource;
        let dataSourceMap = {};

        records.forEach(rec => {
          dataSourceMap[rec.itemShortName] = rec.value;
        });

        records.forEach(rec => {
          if (rec.expression && rec.expression.indexOf(row.itemShortName) > -1) {
            const calcVal = execMathExpress(rec.expression, dataSourceMap);
            let realVal;
            if (!isNaN(calcVal.num) && !isNaN(calcVal.den) && (calcVal.den - 0) !== 0) {
              realVal = calcVal.num / calcVal.den;
              if (!this.judgeDivisor(calcVal.num, calcVal.den)) {
                realVal = realVal.toFixed(3);
              }
            }
            rec.value = realVal;
            console.log(realVal);
          }
        });
      },
      judgeDivisor (m, n) {
        var num = {};
        var i = 0;
        m = m % n;
        while (m !== 0 && !(m in num)) {
          num[m] = i++;
          m = m * 10 % n;
        }
        return m === 0;
      },
      /** 整理成formData */
      classifyIntoFormData (allValues) {
        let main = Object.assign(this.model, allValues.formValue)
        return {
          ...main, // 展开
          records: allValues.tablesValue[0].values,
        }
      },
      submitForm () {
        const that = this;
        // 触发表单验证
        that.$refs.form.validate(valid => {
          if (valid) {
            let records = that.$refs.table.getTableData();
            records = records.filter(rec => {
              return !isNaN(rec.value) && rec.value !== '';
            });
            if (records.length === 0) {
              that.$message.error(`请至少登记一条`)
              return
            }
            records.forEach(rec => {
              Object.assign(rec, that.model);
              rec.createTime = null;
              rec.itemId = rec.id;
              rec.id = null;
            });
            that.confirmLoading = true;
            let httpurl = that.url.add;
            let method = 'post';
            httpAction(httpurl, records, method).then((res) => {
              if (res.success) {
                that.$message.success(res.message);
                that.$emit('ok');
              } else {
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }

        })
      }
    }
  }
</script>
<style lang="less" scoped>
  @import '~@assets/less/common.less';

  /deep/ .ant-modal-body {
    padding: 6px;
  }

  /deep/ .ant-form-item {
    margin-bottom: 3px;
  }
</style>